// extracted by mini-css-extract-plugin
export var directions = "AdultsOnlyBlock-module--directions--2NBYV";
export var box = "AdultsOnlyBlock-module--box--1FY9P";
export var carouselRoot = "AdultsOnlyBlock-module--carouselRoot--1aEuE";